export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[750px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%20folded%20denim%20jacket%20leather%20bag%20and%20sunglasses%20arranged%20on%20light%20gray%20concrete%20surface%20with%20dramatic%20natural%20sunlight%20from%20upper%20left%20creating%20bold%20shadows%20modern%20urban%20editorial%20aesthetic%20with%20rich%20contrast%20and%20breathing%20negative%20space%20suitable%20for%20contemporary%20fashion%20brand%20website%20hero&width=1800&height=1000&seq=hero-bg-v3&orientation=landscape"
          alt="Curated fashion products flat lay background"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 pt-20 md:pt-24 pb-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-16">
            {/* Left: Text */}
            <div className="flex-1 text-center lg:text-left">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight tracking-tight">
                VigorBuy Spreadsheet
              </h1>
              <p className="mt-4 md:mt-6 text-lg md:text-xl text-background-50/85 max-w-xl mx-auto lg:mx-0 leading-relaxed">
                Explore the latest VigorBuy Spreadsheet, compare products, find trusted sellers, and shop smarter with curated buying guides.
              </p>

              {/* Trust Badges */}
              <div className="mt-6 flex flex-wrap justify-center lg:justify-start gap-3">
                {['Updated Daily', 'Product Comparisons', 'Safety Guides', 'Shipping Tutorials', 'Trusted Sellers'].map((badge) => (
                  <span
                    key={badge}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-background-50/90 bg-background-50/10 rounded-full border border-background-50/15 whitespace-nowrap"
                  >
                    <i className="ri-check-line text-sm"></i>
                    {badge}
                  </span>
                ))}
              </div>

              {/* CTAs */}
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-center"
                >
                  Explore VigorBuy Sheet
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-background-50 text-foreground-950 rounded-lg hover:bg-background-100 transition-all duration-200 whitespace-nowrap text-center"
                >
                  Buy It Now
                  <i className="ri-shopping-bag-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* Right: Visual placeholder - subtle card */}
            <div className="hidden lg:flex flex-1 items-center justify-center">
              <div className="relative w-full max-w-md aspect-square rounded-2xl overflow-hidden bg-background-50/10 backdrop-blur-sm border border-background-50/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Single%20premium%20white%20leather%20sneaker%20floating%20on%20dark%20charcoal%20surface%20with%20dramatic%20spotlight%20from%20above%20creating%20strong%20contrast%20and%20sharp%20shadows%20ultra%20clean%20product%20photography%20with%20lots%20of%20negative%20space%20modern%20luxury%20aesthetic%20high%20quality%20editorial%20style%20suitable%20for%20ecommerce%20hero%20card&width=800&height=800&seq=hero-card-v3&orientation=squarish"
                  alt="Featured product showcase"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}